<template>
  <span class="info-hint-root" :class="{ 'info-hint-root-inline': inline }">
    <Tooltip :content="content" :placement="placement">
      <!-- `click.stop` : l'icône vit souvent dans un en-tête triable ou une
           tuile cliquable — la consulter ne doit pas déclencher le parent. -->
      <span class="info-hint" tabindex="0" role="img" :aria-label="content" :data-testid="testId" @click.stop>
        <i class="fas fa-circle-info" aria-hidden="true"></i>
      </span>
    </Tooltip>
  </span>
</template>

<script setup>
/**
 * Petit « point info » : une icône discrète qui affiche une explication au
 * survol (et au focus clavier). Sert à dire, au plus près d'un chiffre ou
 * d'un libellé, D'OÙ VIENT la donnée et COMMENT elle est calculée — sans
 * ouvrir de modale (pour une aide longue, c'est `InfoButton` + `InfoModal`).
 *
 * Le texte est passé en `content` et sert aussi d'`aria-label` : un lecteur
 * d'écran lit l'explication directement sur l'icône.
 */
import Tooltip from './Tooltip.vue'

defineProps({
  content: { type: String, required: true },
  placement: { type: String, default: 'top' },
  // `inline` : s'aligne sur le texte qui précède (libellé de tuile, titre de carte) au lieu d'être un bloc.
  inline: { type: Boolean, default: true },
  testId: { type: String, default: null },
})
</script>

<style scoped>
.info-hint-root {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}
.info-hint-root-inline {
  margin-left: 0.35em;
}
/* Le wrapper du Tooltip est `display:flex; width:100%` par défaut : ici il se
   contente de la place de l'icône. */
.info-hint-root :deep(.tooltip-wrapper) {
  width: auto;
}

.info-hint {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-muted);
  font-size: 0.8em;
  line-height: 1;
  cursor: help;
  border-radius: var(--radius-full);
  transition: color var(--transition-base);
}
.info-hint:hover,
.info-hint:focus-visible {
  color: var(--color-primary);
  outline: none;
}
</style>
